export default "__VITE_ASSET__gRBzX5W8__"